import CrudBaseService from "@/services/CrudBaseService";

export default class CoverageService extends CrudBaseService {
  constructor() {
    super('odoo/coverage');
  }

  findAllByParams(data) {
    return this.http.get(`${this._serviceName}/findAllByParams`, { params: data });
  }

  getRevision(id) {
    return this.http.get(`${this._serviceName}/${id}/revision`);
  }
}
